Backbone = require 'backbone'
Backbone.$ = $

class SupportCommonBaseView extends Backbone.View

  render: ()->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash:()->
    @model?.toJSON() || {}

module.exports = SupportCommonBaseView
